/**
 * This file was generated by TypeScriptGen v0.0.2
 * Any changes to this file will be lost if regenerated 
 */

enum TestType {
    Unknown = "Unknown",
    MineralPackageWaterSoluble = "MineralPackageWaterSoluble",
    ItestPecans = "ItestPecans",
    LeafSap = "LeafSap",
    WetAndDry = "WetAndDry",
    StandardItestLeaf = "StandardItestLeaf",
    ItestLeafInclPh = "ItestLeafInclPh",
    ItestLeafInclBrix = "ItestLeafInclBrix",
    ItestLeafInclBrixPh = "ItestLeafInclBrixPh",
    ItestLeafNuPotiolo = "ItestLeafNuPotiolo",
    Chloride = "Chloride",
    StandardItestPotiolo = "StandardItestPotiolo",
    ItestRoot = "ItestRoot",
    Nickel = "Nickel",
    SilicaWaterSoluble = "SilicaWaterSoluble",
    ItestFarmerSample = "ItestFarmerSample",
    ItestFarmerSamplePBrayIh20Micro = "ItestFarmerSamplePBrayIh20Micro",
    ItestFarmerSamplePBrayIh20 = "ItestFarmerSamplePBrayIh20",
    ItestFarmerSamplePBrayIkclMicro = "ItestFarmerSamplePBrayIkclMicro",
    ItestFarmerSamplePBrayIkcl = "ItestFarmerSamplePBrayIkcl",
    ItestFarmerSamplePBrayIih20Micro = "ItestFarmerSamplePBrayIih20Micro",
    ItestFarmerSamplePBrayIih20 = "ItestFarmerSamplePBrayIih20",
    ItestFarmerSamplePBrayIikclMicro = "ItestFarmerSamplePBrayIikclMicro",
    ItestFarmerSamplePBrayIikcl = "ItestFarmerSamplePBrayIikcl",
    ItestFarmerSamplePBrayIiiMehlichIiih20Micro = "ItestFarmerSamplePBrayIiiMehlichIiih20Micro",
    ItestFarmerSamplePBrayIiiMehlichIiih20 = "ItestFarmerSamplePBrayIiiMehlichIiih20",
    ItestFarmerSamplePBrayIiiMehlichIiikclMicro = "ItestFarmerSamplePBrayIiiMehlichIiikclMicro",
    ItestFarmerSamplePBrayIiiMehlichIiikcl = "ItestFarmerSamplePBrayIiiMehlichIiikcl",
    ItestFarmerSamplePBrayIiiOlsenH20Micro = "ItestFarmerSamplePBrayIiiOlsenH20Micro",
    ItestFarmerSamplePBrayIiiOlsenH20 = "ItestFarmerSamplePBrayIiiOlsenH20",
    ItestFarmerSampleFieldTechnication = "ItestFarmerSampleFieldTechnication",
    ItestFarmerSampleSoilCarbonCom = "ItestFarmerSampleSoilCarbonCom",
    ItestFarmerSampleEc = "ItestFarmerSampleEc",
    ItestFarmerSampleAdditionalPBrayI = "ItestFarmerSampleAdditionalPBrayI",
    ItestFarmerSampleAdditionalPBrayIi = "ItestFarmerSampleAdditionalPBrayIi",
    ItestFarmerSampleAdditionalPBrayIiiMehlichIii = "ItestFarmerSampleAdditionalPBrayIiiMehlichIii",
    ItestFarmerSampleAdditionalPBrayIiiOlsen = "ItestFarmerSampleAdditionalPBrayIiiOlsen",
    ItestFarmerSampleAvailableB = "ItestFarmerSampleAvailableB",
    ItestFarmerSampleChloride = "ItestFarmerSampleChloride",
    ItestFarmerSampleMolybdenum = "ItestFarmerSampleMolybdenum",
    ItestFarmerSampleNitrogen = "ItestFarmerSampleNitrogen",
    ItestFarmerSampleSoil12Water = "ItestFarmerSampleSoil12Water",
    ItestFarmerSampleSoilAdditionalHeavyMetals = "ItestFarmerSampleSoilAdditionalHeavyMetals",
    ItestFarmerSampleSoilAggregateStability = "ItestFarmerSampleSoilAggregateStability",
    ItestFarmerSampleSoilCec = "ItestFarmerSampleSoilCec",
    ItestFarmerSampleSoilColourFingerTest = "ItestFarmerSampleSoilColourFingerTest",
    ItestFarmerSampleSoilExchangeableAl = "ItestFarmerSampleSoilExchangeableAl",
    ItestFarmerSampleSoilITestCarbon = "ItestFarmerSampleSoilITestCarbon",
    ItestFarmerSampleSoilMehlichIiiCompletePackage = "ItestFarmerSampleSoilMehlichIiiCompletePackage",
    ItestFarmerSampleSoilPotentialMinelisableN = "ItestFarmerSampleSoilPotentialMinelisableN",
    ItestFarmerSampleSoilResistSaturatedPasteEx = "ItestFarmerSampleSoilResistSaturatedPasteEx",
    ItestFarmerSampleTexture = "ItestFarmerSampleTexture",
    ItestFarmerSoilEksteenMethod = "ItestFarmerSoilEksteenMethod",
    ItestFarmerSampleSoilCarbonLoi = "ItestFarmerSampleSoilCarbonLoi",
    ItestFarmerSilica = "ItestFarmerSilica"
}

export default TestType;
